import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Hardcoded admin credentials
  const ADMIN_USERNAME = 'admin';
  const ADMIN_PASSWORD = 'admin123';

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setError(''); // Clear error on input change
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Simulate loading delay for better UX
    setTimeout(() => {
      // Check credentials (case-insensitive for username/email)
      const inputUsername = formData.email.trim().toLowerCase();
      const isValidCredentials = 
        (inputUsername === ADMIN_USERNAME.toLowerCase() || inputUsername === 'admin@restaurant.com') &&
        formData.password === ADMIN_PASSWORD;

      if (isValidCredentials) {
        // Store session
        const sessionData = {
          id: 'admin-id',
          email: 'admin@restaurant.com',
          username: ADMIN_USERNAME,
          role: 'admin',
          timestamp: new Date().toISOString()
        };

        if (formData.rememberMe) {
          localStorage.setItem('adminSession', JSON.stringify(sessionData));
        } else {
          sessionStorage.setItem('adminSession', JSON.stringify(sessionData));
        }

        // Navigate to admin dashboard
        navigate('/admin/dashboard');
      } else {
        setError('Invalid username or password');
      }
      
      setLoading(false);
    }, 500); // 500ms delay to show loading state
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="login-icon">🍽️</div>
        
        <h1 className="login-heading">Admin Login</h1>
        <p className="login-subheading">Welcome back! Please login to continue</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email or Username
            </label>
            <input
              type="text"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              placeholder="Enter username or email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className={`password-toggle ${showPassword ? 'show' : 'hide'}`}
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? '👁️' : '👁️'}
              </button>
            </div>
          </div>

          <div className="form-options">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={handleChange}
                className="checkbox-input"
              />
              <span className="checkbox-text">Remember me</span>
            </label>
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;

